"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _reactForm = _interopRequireDefault(require("@micado-digital/react-form"));

var _ShopContext = _interopRequireDefault(require("../../../context/ShopContext"));

var _formContext = _interopRequireDefault(require("@micado-digital/react-form/context/formContext"));

var _Input = _interopRequireDefault(require("@micado-digital/react-form/Input"));

var _Select = _interopRequireDefault(require("@micado-digital/react-form/Select"));

var _Checkbox = _interopRequireDefault(require("@micado-digital/react-form/Checkbox"));

var _Button = _interopRequireDefault(require("@micado-digital/react-form/Button"));

var _Message = _interopRequireDefault(require("@micado-digital/react-form/Message"));

var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));

var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));

var _checkVatRules = _interopRequireDefault(require("../../../config/checkVatRules"));

var _shopTypes = _interopRequireDefault(require("../../../config/shopTypes"));

var _CartContext = _interopRequireDefault(require("../../../context/CartContext"));

var _getStatesByCountry = _interopRequireDefault(require("../../../utils/getStatesByCountry"));

var _de = _interopRequireDefault(require("../../../locals/de.json"));

var _en = _interopRequireDefault(require("../../../locals/en.json"));

var _it = _interopRequireDefault(require("../../../locals/it.json"));

var _FormGuest = _interopRequireDefault(require("./FormGuest.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FormContent = function FormContent(_ref) {
  var buttonLabel = _ref.buttonLabel,
      lang = _ref.lang;
  var css = (0, _FormGuest.default)();

  var _useContext = (0, _react.useContext)(_formContext.default),
      _useContext2 = _slicedToArray(_useContext, 1),
      formConfig = _useContext2[0];

  var _useContext3 = (0, _react.useContext)(_CartContext.default),
      cart = _useContext3.cart;

  var _ref2 = cart || {},
      address = _ref2.address;

  var _useContext4 = (0, _react.useContext)(_ShopContext.default),
      shopData = _useContext4.shopData;

  var countries = shopData.countries,
      shopType = shopData.type;

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      addressData = _useState2[0],
      setAddressData = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      billingCountryCode = _useState4[0],
      setBillingCountryCode = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      billingStateCode = _useState6[0],
      setBillingStateCode = _useState6[1];

  var _useState7 = (0, _react.useState)(),
      _useState8 = _slicedToArray(_useState7, 2),
      countryCode = _useState8[0],
      setCountryCode = _useState8[1];

  var _useState9 = (0, _react.useState)(),
      _useState10 = _slicedToArray(_useState9, 2),
      stateCode = _useState10[0],
      setStateCode = _useState10[1];

  var _useState11 = (0, _react.useState)("private"),
      _useState12 = _slicedToArray(_useState11, 2),
      type = _useState12[0],
      setType = _useState12[1];

  var _ref3 = addressData || {},
      company = _ref3.company,
      billingCompany = _ref3.billingCompany,
      billingEmail = _ref3.billingEmail,
      billingFirstName = _ref3.billingFirstName,
      billingLastName = _ref3.billingLastName,
      billingPhone = _ref3.billingPhone,
      billingSalutation = _ref3.billingSalutation,
      billingStreet = _ref3.billingStreet,
      billingTown = _ref3.billingTown,
      billingZipCode = _ref3.billingZipCode,
      email = _ref3.email,
      firstName = _ref3.firstName,
      lastName = _ref3.lastName,
      phone = _ref3.phone,
      salutation = _ref3.salutation,
      street = _ref3.street,
      town = _ref3.town,
      vat = _ref3.vat,
      zipCode = _ref3.zipCode;

  var _formConfig$errorFiel = formConfig.errorFields,
      errorFields = _formConfig$errorFiel === void 0 ? {} : _formConfig$errorFiel,
      formLocked = formConfig.formLocked,
      _formConfig$response = formConfig.response;
  _formConfig$response = _formConfig$response === void 0 ? {} : _formConfig$response;
  var _formConfig$response$ = _formConfig$response.data;
  _formConfig$response$ = _formConfig$response$ === void 0 ? {} : _formConfig$response$;
  var formMsg = _formConfig$response$.msg;

  var _useState13 = (0, _react.useState)({}),
      _useState14 = _slicedToArray(_useState13, 2),
      formMessageObj = _useState14[0],
      setFormMessageObj = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      billingAddress = _useState16[0],
      setBillingAddress = _useState16[1];

  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  var cartGUID = localStorage.getItem("mco-shop-cart-guid");
  (0, _react.useEffect)(function () {
    if ((0, _isEmpty.default)(address)) return;
    var _address = {};
    var billingAddress = address === null || address === void 0 ? void 0 : address.billing;
    var shippingAddress = address === null || address === void 0 ? void 0 : address.shipping;

    if (billingAddress) {
      _address.billingCompany = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.company;
      _address.billingEmail = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.email;
      _address.billingFirstName = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.firstName;
      _address.billingLastName = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.lastName;
      _address.billingPhone = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.phone;
      _address.billingSalutation = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.salutation;
      _address.billingStreet = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.street;
      _address.billingTown = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.town;
      _address.billingZipCode = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.zipCode;
      setBillingAddress(true);
      setBillingCountryCode(billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.countryCode);
      setBillingStateCode(billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.stateCode);
    }

    _address.company = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.company;
    _address.email = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.email;
    _address.firstName = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.firstName;
    _address.lastName = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.lastName;
    _address.phone = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.phone;
    _address.salutation = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.salutation;
    _address.street = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.street;
    _address.town = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.town;
    _address.type = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.type;
    _address.vat = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.vat;
    _address.zipCode = shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.zipCode;
    setAddressData(_address);
    setCountryCode(shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.countryCode);
    setStateCode(shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.stateCode);
    setType(shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.type);
  }, [address]);
  (0, _react.useEffect)(function () {
    setAddressData(function (prevAddressData) {
      return _objectSpread(_objectSpread({}, prevAddressData), {}, {
        billingCountryCode: billingCountryCode,
        billingStateCode: billingStateCode
      });
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billingCountryCode, billingStateCode]);
  (0, _react.useEffect)(function () {
    setAddressData(function (prevAddressData) {
      return _objectSpread(_objectSpread({}, prevAddressData), {}, {
        countryCode: countryCode,
        stateCode: stateCode,
        type: type
      });
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode, stateCode, type]);
  (0, _react.useEffect)(function () {
    if (!formMsg) return;

    switch (formMsg) {
      case "ok":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.success.ADDRESS_SAVED",
              l: l
            }),
            type: "success"
          });
          break;
        }

      case "parameter_missing":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.ADDRESS_NOT_SAVED",
              l: l
            }),
            type: "error"
          });
          break;
        }

      case "parameter_invalid":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.ADDRESS_NOT_SAVED",
              l: l
            }),
            type: "error"
          });
          break;
        }

      case "authorization_error":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.CUSTOMER_NOT_AUTHORIZED",
              l: l
            }),
            type: "error"
          });
          break;
        }

      case "vat_invalid":
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.VAT_INVALID",
              l: l
            }),
            type: "error"
          });
          break;
        }

      case "not_found":
      default:
        {
          setFormMessageObj({
            message: /*#__PURE__*/_react.default.createElement(_Local.default, {
              identifier: "reactShop.messages.errors.ADDRESS_NOT_SAVED",
              l: l
            }),
            type: "error"
          });
          break;
        }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [formConfig]);
  var billingStates = (0, _react.useMemo)(function () {
    return (0, _getStatesByCountry.default)(countries, billingCountryCode);
  }, [countries, billingCountryCode]);
  var states = (0, _react.useMemo)(function () {
    return (0, _getStatesByCountry.default)(countries, countryCode);
  }, [countries, countryCode]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cartGUID && /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "cartGUID",
    value: cartGUID
  }), /*#__PURE__*/_react.default.createElement(_Select.default, {
    error: errorFields["salutation"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.salutation"),
    name: "salutation",
    required: true,
    subItems: [{
      "attr-value": l("reactShop.addresses.Mr"),
      text: l("reactShop.addresses.Mr")
    }, {
      "attr-value": l("reactShop.addresses.Mrs"),
      text: l("reactShop.addresses.Mrs")
    }, {
      "attr-value": l("reactShop.addresses.Divers"),
      text: l("reactShop.addresses.Divers")
    }],
    value: salutation,
    SelectProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: l("reactShop.addresses.company"),
    name: "company",
    value: company,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["firstName"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.firstname"),
    name: "firstName",
    required: true,
    value: firstName,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["lastName"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.lastname"),
    name: "lastName",
    required: true,
    value: lastName,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["street"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.street"),
    name: "street",
    required: true,
    value: street,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["zipCode"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.zipcode"),
    name: "zipCode",
    required: true,
    value: zipCode,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["town"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.town"),
    name: "town",
    required: true,
    value: town,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Select.default, {
    error: errorFields["countryCode"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.country"),
    name: "countryCode",
    required: true,
    subItems: countries === null || countries === void 0 ? void 0 : countries.map(function (country) {
      return {
        "attr-value": country.isoCode,
        text: country.title
      };
    }),
    value: countryCode,
    SelectProps: {
      variant: "outlined",
      onChange: function onChange(e) {
        setCountryCode(e.target.value);
        setStateCode("");
      }
    }
  }), !(0, _isEmpty.default)(states) && /*#__PURE__*/_react.default.createElement(_Select.default, {
    label: l("reactShop.addresses.state"),
    name: "stateCode",
    subItems: states === null || states === void 0 ? void 0 : states.map(function (state) {
      return {
        "attr-value": state.code,
        text: state.title
      };
    }),
    value: stateCode,
    SelectProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["phone"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.phone"),
    name: "phone",
    required: true,
    value: phone,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["email"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.email"),
    name: "email",
    required: true,
    value: email,
    TextfieldProps: {
      type: "email",
      variant: "outlined"
    }
  }), shopType === _shopTypes.default.MIXED ? /*#__PURE__*/_react.default.createElement(_Select.default, {
    error: errorFields["type"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.myAccount.customer.labels.requiredField",
      l: l
    }),
    label: l("reactShop.myAccount.customer.labels.type"),
    name: "type",
    required: true,
    subItems: [{
      "attr-value": "private",
      text: l("reactShop.myAccount.customer.labels.private")
    }, {
      "attr-value": "company",
      text: l("reactShop.myAccount.customer.labels.company")
    }],
    value: type,
    SelectProps: {
      variant: "outlined",
      onChange: function onChange(e) {
        setType(e.target.value);
      }
    }
  }) : /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "type",
    value: shopType === _shopTypes.default.B2B ? "company" : "private"
  }), (shopType === _shopTypes.default.B2B || type === "company" || (0, _checkVatRules.default)(countryCode, type)) && /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["vat"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.vat"),
    name: "vat",
    required: true,
    value: vat,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    checked: billingAddress,
    label: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.billingAddress",
      l: l
    }),
    name: "useSeparateBillingAddress",
    setChecked: setBillingAddress,
    value: true
  }), billingAddress && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Select.default, {
    error: errorFields["billingSalutation"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.salutation"),
    name: "billingSalutation",
    required: true,
    subItems: [{
      "attr-value": l("reactShop.addresses.Mr"),
      text: l("reactShop.addresses.Mr")
    }, {
      "attr-value": l("reactShop.addresses.Mrs"),
      text: l("reactShop.addresses.Mrs")
    }, {
      "attr-value": l("reactShop.addresses.Divers"),
      text: l("reactShop.addresses.Divers")
    }],
    value: billingSalutation,
    SelectProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: l("reactShop.addresses.company"),
    name: "billingCompany",
    value: billingCompany,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["billingFirstName"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.firstname"),
    name: "billingFirstName",
    required: true,
    value: billingFirstName,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["billingLastName"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.lastname"),
    name: "billingLastName",
    required: true,
    value: billingLastName,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["billingStreet"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.street"),
    name: "billingStreet",
    required: true,
    value: billingStreet,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["billingZipCode"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.zipcode"),
    name: "billingZipCode",
    required: true,
    value: billingZipCode,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["billingTown"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.town"),
    name: "billingTown",
    required: true,
    value: billingTown,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Select.default, {
    error: errorFields["billingCountryCode"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.country"),
    name: "billingCountryCode",
    required: true,
    subItems: countries === null || countries === void 0 ? void 0 : countries.map(function (country) {
      return {
        "attr-value": country.isoCode,
        text: country.title
      };
    }),
    value: billingCountryCode,
    SelectProps: {
      variant: "outlined",
      onChange: function onChange(e) {
        setBillingCountryCode(e.target.value);
        setBillingStateCode("");
      }
    }
  }), !(0, _isEmpty.default)(billingStates) && /*#__PURE__*/_react.default.createElement(_Select.default, {
    label: l("reactShop.addresses.state"),
    name: "billingStateCode",
    subItems: billingStates === null || billingStates === void 0 ? void 0 : billingStates.map(function (state) {
      return {
        "attr-value": state.code,
        text: state.title
      };
    }),
    value: billingStateCode,
    SelectProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["billingPhone"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.phone"),
    name: "billingPhone",
    required: true,
    value: billingPhone,
    TextfieldProps: {
      variant: "outlined"
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    error: errorFields["billingEmail"],
    errorMessage: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.addresses.requiredField",
      l: l
    }),
    label: l("reactShop.addresses.email"),
    name: "billingEmail",
    required: true,
    value: billingEmail,
    TextfieldProps: {
      type: "email",
      variant: "outlined"
    }
  })), !(0, _isEmpty.default)(formMessageObj) && formMessageObj.message && /*#__PURE__*/_react.default.createElement(_Message.default, {
    text: formMessageObj.message,
    type: formMessageObj.type
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.buttons, "mco-shop-addresses-form__buttons")
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    label: buttonLabel ? buttonLabel : l("reactShop.addresses.buttons.save"),
    locked: formLocked,
    ButtonProps: {
      color: "primary",
      variant: "contained"
    },
    type: "submit"
  })));
};

var FormGuest = function FormGuest(_ref4) {
  var buttonLabel = _ref4.buttonLabel,
      lang = _ref4.lang,
      onSubmit = _ref4.onSubmit;
  var REACT_APP_PATH = process.env.REACT_APP_PATH;
  var css = (0, _FormGuest.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.list, "mco-shop-addresses-form")
  }, /*#__PURE__*/_react.default.createElement(_reactForm.default, {
    authorization: true,
    action: "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.CartApi/UpdateGuestAddress.api"),
    method: "POST",
    contentType: "formData",
    onAfterSubmit: function onAfterSubmit(data) {
      if (onSubmit) onSubmit(data);
    }
  }, /*#__PURE__*/_react.default.createElement(FormContent, {
    buttonLabel: buttonLabel,
    lang: lang
  })));
};

var _default = FormGuest;
exports.default = _default;